// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3OMCn","inputDescription":"styles_inputDescription__JxGFz"};